export default __webpack_public_path__ + "static/media/case_2.beb8e2e2.jpg";